import React from "react"
import Table from "material-ui/Table"
import TableHeader from "material-ui/Table/TableHeader"
import TableBody from "material-ui/Table/TableBody"
import EquipmentTimecardTableHeader from "./EquipmentTimecardTableHeader"
import EquipmentTimecardTableRow from "./EquipmentTimecardTableRow"
import EquipmentTimecardTotalsRow from "./EquipmentTimecardTotalsRow"
import EquipmentTimecardGrandTotalRow from "./EquipmentTimecardGrandTotalRow"
import { ITimecardWeek, ITimecardDay, IPunchSetDocument } from "../../models"
interface IProps {
    fullPunchSes: IPunchSetDocument[]
    timecardWeek: ITimecardWeek
    readonly: boolean
    hierarchyItemId: string
    positionId?: string
    onAddPunchToTimecardDay(timecardDay: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, employeeId: string, shiftId: string, jobId: string, phaseId: string, isPunchIn: boolean, pairedPunchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    onConfirmDelete(punchId: string): void
    openDailyHistoryDrawer(date: number): void
    reloadTimecard(msg: string): void
}

const EquipmentTimecardWeekTable: React.SFC<IProps> = (props: IProps) => {
    const timecardWeek = props.timecardWeek
    return (
        <div className="EquipmentTimecardWeekTable">
            <Table selectable={false}>
                <TableHeader>
                    <EquipmentTimecardTableHeader timecardDays={timecardWeek.Days} openDailyHistoryDrawer={props.openDailyHistoryDrawer} />
                </TableHeader>
                <TableBody showRowHover={false} deselectOnClickaway={false}>
                    <EquipmentTimecardTableRow
                        fullPunchSets={props.fullPunchSes}
                        timecardDays={timecardWeek.Days}
                        key="punchSetsRow"
                        addPunch={props.onAddPunchToTimecardDay}
                        onTimeChange={props.onTimeChange}
                        onConfirmDelete={props.onConfirmDelete}
                        timecardLocked={false}
                        readonly={props.readonly}
                        hierarchyItemId={props.hierarchyItemId}
                        positionId={props.positionId}
                        reloadTimecard={props.reloadTimecard}
                    />
                    <EquipmentTimecardTotalsRow timecardDays={timecardWeek.Days} />
                    <EquipmentTimecardGrandTotalRow timecardWeek={timecardWeek} />
                </TableBody>
            </Table>
        </div>
    )
}

export default EquipmentTimecardWeekTable
